import { faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const LTCNavList: MenuItem[] = [
  {
    id: 1,
    name: 'contactInfo',
    componentName: 'ContactInfo',
    complete: false,
  },
  {
    id: 2,
    name: 'incomeExpense',
    componentName: 'IncomeExpense',
    complete: false,
    icon: faMoneyBillTrendUp,
    subItems: [
      {
        id: 21,
        name: 'bedCounts',
        confirmNavigation: true,
        complete: false,
        componentName: "BedCounts"
      },
      {
        id: 22,
        name: 'revenue',
        confirmNavigation: true,
        complete: false,
        componentName: "Subsidy",
        hasTabs: true,
        subItems: [
          {
            id: 221,
            name: 'revenue',
            complete: false
          },
          {
            id: 222,
            name: 'nonOperatingIncomeRevenues',
            complete: false
          },
          {
            id: 223,
            name: 'rentalLoss',
            complete: false
          }
        ]
      },
      {
        id: 23,
        name: 'expenses',
        confirmNavigation: true,
        componentName: 'ExpenseContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 231,
            name: 'operatingExpenses',
            complete: false
          },
          {
            id: 232,
            name: 'fixedCharges',
            complete: false
          },
          {
            id: 233,
            name: 'nonOperatingIncomeExpenses',
            complete: false
          }
        ]
      },
      {
        id: 24,
        name: 'reserveForReplacementAllowance',
        confirmNavigation: true,
        componentName: 'ReserveForReplacementAllowance',
        complete: false,
      },
      {
        id: 25,
        name: 'capitalExpSummary',
        confirmNavigation: true,
        complete: false,
        componentName: 'CapitalCostsSummary'
      }
    ],
  },
  {
    id: 3,
    name: 'commercial',
    complete: false,
    icon: faCartShopping,
    subItems: [
      {
        id: 31,
        name: 'leaseInformationTable',
        componentName: 'LeaseInfo',
        complete: false
      },
      {
        id: 32,
        name: 'vacantAskingRate',
        complete: false,
        componentName: 'VacantAskingRate',
      },
      {
        id: 33,
        name: 'parkingSummary',
        complete: false,
        componentName: 'ParkingPropertySummary',
      }
    ]
  },
  {
    id: 4,
    name: 'comments',
    complete: false,
    componentName: 'Comment'
  },
  {
    id: 5,
    name: 'summaryReview',
    complete: false,
    componentName: 'Summary',
    icon: faFilePdf
  },
  {
    id: 6,
    name: 'submit',
    complete: false,
    componentName: 'Submit',
    icon: faFileInvoiceDollar
  }
]

export default LTCNavList
